module.exports = __webpack_public_path__ + "img/earth.2e0d7019.svg";